import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.6rem;
`;

export const ConfirmDeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;

export const ConfirmDeleteTitle = styled.h3`
  font-size: 1.8rem;
  color: #0f0f0f;
  letter-spacing: 0.168rem;
  text-transform: uppercase;
`;

export const Divider = styled.div`
  position: relative;
  width: calc(100% + 60px);
  margin: 0px -30px 10px -30px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const ConfirmDeleteText = styled.p`
  opacity: 0.65;
  margin-bottom: 3.2rem;
`;

export const ConfirmDeleteButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
